import React from 'react';
import { motion } from 'framer-motion';

const DNSRecordListLoading: React.FC = () => {
  return (
    <motion.div
      className="text-center py-8"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <div className="w-12 h-12 bg-slate-100 dark:bg-slate-800 rounded-full flex items-center justify-center mx-auto mb-3">
        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
      </div>
      <p className="text-body-small text-slate-500 dark:text-slate-400">
        Loading DNS records...
      </p>
    </motion.div>
  );
};

export default DNSRecordListLoading;